export default {
  token: {
    colorPrimary: '#8E2DB0',
    borderRadius: 4,
  },
  components: {
    Steps: {
      descriptionMaxWidth: 75,
    },
  },
};